// extracted by mini-css-extract-plugin
export default {"header":"InvitationsTable__header___xRT3C"};